import { render, staticRenderFns } from "./sync-queue-icon.vue?vue&type=template&id=6e7cd26b&scoped=true&"
import script from "./sync-queue-icon.vue?vue&type=script&lang=ts&"
export * from "./sync-queue-icon.vue?vue&type=script&lang=ts&"
import style0 from "./sync-queue-icon.vue?vue&type=style&index=0&id=6e7cd26b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e7cd26b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\VelipetteriLehto\\Projects\\Europress\\client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6e7cd26b')) {
      api.createRecord('6e7cd26b', component.options)
    } else {
      api.reload('6e7cd26b', component.options)
    }
    module.hot.accept("./sync-queue-icon.vue?vue&type=template&id=6e7cd26b&scoped=true&", function () {
      api.rerender('6e7cd26b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/view/partial/sync-queue-icon.vue"
export default component.exports